import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-data-table',
	templateUrl: './data-table.component.html',
	styleUrls: ['./data-table.component.scss'],
	providers: [CurrencyPipe],
})
export class DataTableComponent implements AfterViewInit {
	@Input() displayedColumns: Array<string> = [];
	@Input() tableHeaders: Array<string> = [];
	@Input() dataType: Array<string> = [];
	@Input() tableIcons: Array<string> = [];
	@Input() dataSource: any;
	@Input() totalNumberOfRecords;
	@Input() PAGE_SIZE;
	@Input() isStaticPagination: boolean = true;
	@Input() rowClickAction: Object;

	@Output() currentPage: EventEmitter<any> = new EventEmitter();
	@Output() navigateTo: EventEmitter<any> = new EventEmitter();

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	constructor(private utilService: UtilService) {}

	ngAfterViewInit() {
		setTimeout(() => {
			this.initializePage();
			this.initializeSort();
		}, 500);
	}

	initializePage() {
		this.dataSource.paginator = this.paginator;
	}

	initializeSort() {
		this.dataSource.sort = this.sort;
	}

	emitPageNumber() {
		this.currentPage.emit(this.paginator.pageIndex);
	}

	route(row: any) {
		this.navigateTo.emit(row);
	}

	reset() {
		if (
			!this.utilService.isNullOrUndefined(this.paginator) &&
			!this.utilService.isNullOrUndefined(this.paginator.pageIndex)
		) {
			this.paginator.pageIndex = 0;
		}
	}
}
